import React, { useMemo } from 'react';
import { Badge, Empty, Input, List, Tag, Typography } from 'antd';

const { Text } = Typography;

export type LibraryRow = {
  id: string;
  code: string;
  name: string;
  status?: string;
  package_count?: number;
  discipline_code?: string;
};

export interface EpcWbsLibraryRailProps {
  libraries: LibraryRow[];
  loading?: boolean;
  selectedLibraryId?: string;
  onSelect: (id: string) => void;
  search: string;
  onSearchChange: (v: string) => void;
}

export const EpcWbsLibraryRail: React.FC<EpcWbsLibraryRailProps> = ({
  libraries,
  loading,
  selectedLibraryId,
  onSelect,
  search,
  onSearchChange,
}) => {
  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return libraries;
    return libraries.filter(
      (l) =>
        l.code.toLowerCase().includes(q) ||
        l.name.toLowerCase().includes(q) ||
        (l.discipline_code || '').toLowerCase().includes(q)
    );
  }, [libraries, search]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <div style={{ padding: '12px 12px 8px' }}>
        <Text strong>Catalogues</Text>
        <Input.Search
          allowClear
          size="small"
          placeholder="Filter catalogues"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{ marginTop: 8 }}
        />
      </div>
      <div style={{ flex: 1, overflow: 'auto', padding: '0 8px 12px' }}>
        {filtered.length === 0 && !loading ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No catalogues" />
        ) : (
          <List
            loading={loading}
            size="small"
            dataSource={filtered}
            renderItem={(item) => {
              const selected = selectedLibraryId === String(item.id);
              return (
                <List.Item
                  onClick={() => onSelect(String(item.id))}
                  style={{
                    cursor: 'pointer',
                    borderRadius: 8,
                    padding: '10px 12px',
                    marginBottom: 4,
                    background: selected ? '#e6f4ff' : undefined,
                    border: selected ? '1px solid #91caff' : '1px solid transparent',
                  }}
                >
                  <div style={{ width: '100%' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                      <Text strong ellipsis style={{ flex: 1 }}>
                        {item.code}
                      </Text>
                      <Badge count={item.package_count ?? 0} showZero color="#1677ff" />
                    </div>
                    <Text type="secondary" ellipsis style={{ display: 'block', fontSize: 12 }}>
                      {item.name}
                    </Text>
                    <Tag
                      color={item.status === 'Active' ? 'success' : 'default'}
                      style={{ marginTop: 6 }}
                    >
                      {item.status || 'Draft'}
                    </Tag>
                  </div>
                </List.Item>
              );
            }}
          />
        )}
      </div>
    </div>
  );
};
